<template>
  <section class="d-flex w-100">
    <article class="mail-envelope">
      <div class="envelope-body front">
        <div class="envelope-door" :class="{'bg-white': !configurations.HasLetter}">
          <div v-if="configurations.HasLetter" class="mail-tail" />
        </div>
        <div v-if="configurations.HasLetter" class="envelope-door-open">
          <div class="top-left" />
          <div class="top-right" />
        </div>
        <div v-if="configurations.HasStamp" class="position-absolute align-self-center stamp d-flex">
          <img :src="logoUrl" width="86" height="86">
        </div>
        <div v-if="configurations.HasCoverText" class="envelope-cover-text d-flex flex-column bg-light cover-text col-lg-5 col-sm-7 col-xxs-10 p-4 align-self-start m-5 position-absolute">
          <component :is="configurations.CoverText" />
        </div>
        <div class="border">
          <div class="left" />
          <div class="top" />
          <div class="top-left" />
          <div class="top-right" />
          <div class="bottom" />
          <div class="right" />
        </div>
        <div v-if="configurations.HasButton" class="d-block position-absolute align-self-end justify-content-center w-100 py-3">
          <b-button variant="success" class="d-flex mx-auto mb-3 px-5 shadow" @click="login()">
            {{ configurations.ButtonText }}
          </b-button>
        </div>
      </div>
      <component :is="configurations.LetterText" v-if="configurations.HasLetter" />
    </article>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
import ActivatedSuccessfullyLetter from '@/components/ActivatedSuccessfullyLetter.vue'
import SendActivationCoverText from '@/components/SendActivationCoverText.vue'
export default {
  name: 'Envelope',
  props: {
    configurations: Object
  },
  computed: {
    ...mapGetters({
      portalConfigurations: 'tenantDesign/config'
    }),
    portalGeneralInfo () {
      return this.portalConfigurations.general
    },
    logoUrl () {
      return this.portalConfigurations.general.logoUrl ? this.portalConfigurations.general.logoUrl : '/logo-xbuzzi.png'
    }
  },
  components: {
    ActivatedSuccessfullyLetter,
    SendActivationCoverText
  },
  methods: {
    login () {
      this.$router.push({ path: 'login' })
    }
  }
}
</script>
